import axios from './http'

export function login (UserDTO) {
  return axios({
    url: '/api/auth/login',
    method: 'post',
    data: UserDTO
  })
}

export function consoleInit (token) {
  return axios({
    url: '/api/auth/console',
    method: 'get',
    headers: {
      'authorization': token,
      'Content-Type':'multipart/form-data'
    },
  })
}

export function getQrCode (url) {
  return axios({
    url: '/api/auth/qrcode/' + url,
    method: 'GET',
  })
}

export function getToken() {
  return axios({
    url: '/api/auth/getToken' ,
    method: 'POST'
  })
}

export function saveTrainingUser(token,data) {
  return axios({
    url: '/api/auth/saveTrainingUser' ,
    method: 'POST',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function querySupplierData (token,supplierId) {
  return axios({
    url: '/api/supplier/querySupplierData/'+supplierId,
    method: 'GET',
    headers: {
      'authorization': token
    }
  })
}

export function supplierDataSaleJump (token,supplierId) {
  return axios({
    url: '/api/supplier/supplierDataSaleJump/'+supplierId,
    method: 'GET',
    headers: {
      'authorization': token
    }
  })
}
